import faker from 'faker';
import { useRef } from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import twitterFill from '@iconify/icons-eva/twitter-fill';
import linkedinFill from '@iconify/icons-eva/linkedin-fill';
import facebookFill from '@iconify/icons-eva/facebook-fill';
import roundArrowRightAlt from '@iconify/icons-ic/round-arrow-right-alt';
import instagramFilled from '@iconify/icons-ant-design/instagram-filled';
// material
import { useTheme } from '@material-ui/core/styles';
import { Box, Card, Button, Container, Typography, IconButton, Grid, Paper, Stack, Chip } from '@material-ui/core';
//
import { varFadeIn, varFadeInUp, MotionInView, varFadeInDown } from '../../animate';
import { CarouselControlsArrowsBasic2 } from '../../carousel';
import { gallery,skynicheAIservices } from '../faqs/data';
import { useNavigate, useLocation, useParams } from 'react-router';

// ----------------------------------------------------------------------

MemberCard.propTypes = {
  caseStudy: PropTypes.object
};

function MemberCard({ caseStudy, }) {
  console.log(caseStudy);
  
  const { id, imageUrl, title, title1, icon, title2, imageCarousal,
imgSrc,category} = caseStudy;
  const navigate = useNavigate();

  const handleNavigation = () => {
   {category ? navigate(`/services/${title2}`, { state: { caseStudy } }): navigate(`/case_study/${title2}`, { state: { caseStudy } });}
  };

  return (
    <Paper variant="outlined" key={id} sx={{ border: '2px solid #e1e1df', borderRadius: 0.1, height: category?"400px":'470px', mr: { xs: 0, sm: 2, md: 2 } }}>
      <Box component="img" src={ title2=== 'seema-jaswal' ? imageCarousal : imageUrl||
imgSrc
} sx={{ width: '100%', height: '210px', objectFit: 'cover' }} />
      <Box sx={{ p: 2 }}>
        <Chip
          icon={<Stack className={icon} sx={{ fontSize: '1rem' }} />}
          label={title || category}
          sx={{
            backgroundColor: '#019bdc',
            borderRadius: 0.1,
            color: '#fff',
            mb: 1,
            fontFamily:
              '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
            fontWeight: '600',
            fontSize: '13px',
            backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.15),hsla(0,0%,100%,0))',
            padding: 0.5,
            alignContent: 'center',
            textAlign: 'center',
          }}
        />
        <Typography
          sx={{
            mt: 1,
            mb: 2,
            mb: '1rem',
            fontSize: '24px',
            fontWeight: 400,
            color: '#2f78c4',
            lineHeight: 1.2,
            cursor: 'pointer',
            '&:hover': {
              textDecoration: 'underline'
            },
            fontFamily: '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 3,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
          onClick={ handleNavigation}
        >
          {title1}
        </Typography>
        <Box sx={{ textAlign: 'left', bottom: 8, position: 'absolute' }}>
          <Button
            onClick={handleNavigation}
            size="small"
            sx={{ cursor: 'pointer', color: '#2f78c4', fontWeight: '600', fontSize: '15px' }}
            endIcon={<Stack className="bx--right-arrow" style={{ fontSize: '1rem', marginTop: 0.5 }} />}
          >
            Know More
          </Button>
        </Box>
      </Box>
    </Paper>
  );
}

export default function RelatedCaseStudyCarousal() {
  const carouselRef = useRef();
  const theme = useTheme();
  const location = useLocation();
  const { title2 } = useParams();
  const { caseStudy: stateCaseStudy } = location.state || {};
// fetch path for case checking

const currentpath = location.pathname.replace(/^\/services\//, '');
const servicesAI=skynicheAIservices[0].services
const filteredServicesAI =servicesAI.filter(
  (service) => service.title2 !== currentpath
);
console.log(servicesAI);
const isAIServicesPage =
  currentpath === "ai-development-company" ||
  currentpath === "ai-automation-services" ||
  currentpath === "ai-integration-services" ||
  currentpath === "ai-agents-for-business";

  // Fetch case study from gallery if not available in location.state
  const caseStudy = stateCaseStudy || gallery.find(item => item.title2 === title2);

  if (!caseStudy) {
    // Handle case when caseStudy is not found, possibly navigate to a 404 page
    return <Typography>Case Study not found</Typography>;
  }

  const settings = {
    speed: 500,
    slidesToShow: 4,
    autoplay: true,
    autoplaySpeed: 2000,
    centerMode: true,
    centerPadding: '0 80px',
    rtl: Boolean(theme.direction === 'rtl'),
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 3,
          autoplay: true,
          autoplaySpeed: 2000 
        }
      },
      {
        breakpoint: 959,
        settings: {
          slidesToShow: 2,
          autoplay: true,
          autoplaySpeed: 2000
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          autoplay: true,
          autoplaySpeed: 2000
        }
      }
    ]
  };

  const handlePrevious = () => {
    carouselRef.current.slickPrev();
  };

  const handleNext = () => {
    carouselRef.current.slickNext();
  };

  const filteredCaseStudies = gallery.filter(
    (cs) => cs?.id !== caseStudy?.id && cs?.id !== 4
  );

const adjustedSettings = {
  ...settings,
  slidesToShow: Math.min(filteredServicesAI.length, settings.slidesToShow),
  infinite: filteredServicesAI.length > settings.slidesToShow,
  centerMode: filteredServicesAI.length > settings.slidesToShow,
  centerPadding: filteredServicesAI.length > settings.slidesToShow ? '0 80px' : '0px'
};

  return (
    <>
    
    {isAIServicesPage ? <Grid maxWidth="lg" sx={{ textAlign: 'left', overflow: 'hidden', mb: 5 }}>
  <Grid sx={{ position: 'relative', overflow: 'hidden' }}>
    <Slider ref={carouselRef} {...adjustedSettings}>
      {filteredServicesAI.map((caseStudy) => (
        <MotionInView key={caseStudy.id} variants={varFadeIn}>
          <MemberCard caseStudy={caseStudy} />
        </MotionInView>
      ))}
    </Slider>

    <Grid sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
      {filteredServicesAI.length > 4 && (
        <CarouselControlsArrowsBasic2
          onNext={handleNext}
          onPrevious={handlePrevious}
          sx={{ transform: 'translateY(-64px)' }}
        />
      )}
    </Grid>

    <Grid sx={{ display: { xs: 'block', sm: 'block', md: 'none' } }}>
      <CarouselControlsArrowsBasic2
        onNext={handleNext}
        onPrevious={handlePrevious}
        sx={{ transform: 'translateY(-64px)' }}
      />
    </Grid>
  </Grid>
</Grid>
    :
    <Grid maxWidth="lg" sx={{ textAlign: 'left', overflow: 'hidden', mb: 5 }}>

      <Grid sx={{ position: 'relative', overflow: 'hidden' }}>
        <Slider ref={carouselRef} {...adjustedSettings}>
          {filteredCaseStudies.map((caseStudy) => (
            <MotionInView key={caseStudy.title} variants={varFadeIn}>
              <MemberCard key={caseStudy.title} caseStudy={caseStudy} />
            </MotionInView>
          ))}
        </Slider>
        <Grid sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
          {filteredCaseStudies.length > 4 && (
            <CarouselControlsArrowsBasic2 onNext={handleNext} onPrevious={handlePrevious} sx={{ transform: 'translateY(-64px)' }} />
          )}
        </Grid>

        <Grid sx={{ display: { xs: 'block', sm: 'block', md: 'none' } }}>
          <CarouselControlsArrowsBasic2 onNext={handleNext} onPrevious={handlePrevious} sx={{ transform: 'translateY(-64px)' }} />
        </Grid>

      </Grid>
    </Grid>}
    
    </>
  );
}
